module.exports = __webpack_public_path__ + "img/notepad-green.a284a24b.svg";